import { render, staticRenderFns } from "./Afiliados.vue?vue&type=template&id=0597aa8f"
import script from "./Afiliados.vue?vue&type=script&lang=ts"
export * from "./Afiliados.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports